import { api_POST } from "./_api.js";


const solicitacaoFiscalizacaoFinalizada_api = {
    post: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`SolicitacaoFiscalizacaoFinalizada`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }

}

export default solicitacaoFiscalizacaoFinalizada_api;
